export function disableAccessibility( Splide, Components, options) {
    function mount() {
        let elements = Components.Elements;

        Splide.on('ready move resize', setTabindex);

        elements.root.removeAttribute('role');
        elements.root.removeAttribute('aria-roledescription');

        elements.track.removeAttribute('aria-live');
        elements.track.removeAttribute('aria-atomic');

        elements.list.removeAttribute('role');

        elements.slides.forEach(slide => {
            slide.removeAttribute('role');
            slide.removeAttribute('aria-roledescription');
            slide.removeAttribute('aria-label');

            slide.querySelectorAll('a').forEach(a => {
                a.setAttribute('tabindex', '-1');
            });
        });
    }

    function setTabindex() {
        Components.Elements.slides.forEach(slide => {
            slide.querySelectorAll('a').forEach(a => {
                a.setAttribute('tabindex', '-1');
            });
        });
    }

    return {
        mount,
    };
}